<template>
  <el-card class="m-b">
    <div slot="header">
      <span class="saas-card-header-name">询价单基本信息</span>
    </div>
    <el-form label-position="right" label-width="130px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="项目名称:" prop="cgglXmName">
            <el-input
              v-model="inquireForm.cgglXmName"
              disabled
              placeholder="系统自动创建"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目类型:" prop="cgglXmLeiXing">
            <el-input
              :disabled="true"
              v-model="inquireForm.cgglXmLeiXing"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="询单单号:" prop="inquireCode">
            <el-input
              v-model="inquireForm.inquireCode"
              disabled
              placeholder="系统自动创建"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="询单名称:" prop="inquireName">
            <el-input
              :disabled="true"
              v-model="inquireForm.inquireName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="预算金额:" prop="cgglYuSuanJine">
            <el-input
              v-model="inquireForm.cgglYuSuanJine"
              disabled
              placeholder="系统自动创建"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="中标（选）供应商数量:" prop="cgglZhongBiaoGysNum">
            <el-input
              :disabled="true"
              v-model="inquireForm.cgglZhongBiaoGysNum"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="采购单位:" prop="cgglCaiGouDanWei">
            <el-input
              :disabled="true"
              type="text"
              v-model="inquireForm.cgglCaiGouDanWei"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请部门:" prop="cgglShenQingBuMen">
            <el-input
              :disabled="true"
              type="text"
              v-model="inquireForm.cgglShenQingBuMen"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="询单联系人:" prop="duiJieJingBanRenName">
            <el-input
              :disabled="true"
              type="text"
              v-model="inquireForm.duiJieJingBanRenName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人电话:" prop="duiJieJingBanRenLianXiFangShi">
            <el-input :disabled="true" v-model="inquireForm.duiJieJingBanRenLianXiFangShi">
              <!-- <el-select
                :disabled="true"
                size="mini"
                style="width:100px"
                v-model="inquireForm.contactPhonePrefix"
                slot="prepend"
                placeholder="请选择"
              >
                <el-option label="中国+86" value="+86"></el-option>
              </el-select> -->
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="cgglCgwjGroupId">
            <span slot="label">
              采购文件(对内)
              <el-tooltip
                class="item"
                effect="dark"
                content="此文件仅用于公司内部审批。"
                placement="top-start"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </span>
            <zs-upload
              :isDisabled="true"
              drag
              :multiple="false"
              v-model="inquireForm.cgglCgwjGroupId"
            >
            </zs-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="cgglQtfjGroupId">
            <span slot="label">
              其他文件(对内)
              <el-tooltip
                class="item"
                effect="dark"
                content="此文件仅用于公司内部审批。"
                placement="top-start"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </span>
            <zs-upload
              :isDisabled="true"
              drag
              :multiple="false"
              v-model="inquireForm.cgglQtfjGroupId"
            >
            </zs-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="cgglCgwjGroupIdDuiWai">
            <span slot="label">
              <span style="color: #F56C6C;">*</span>采购文件(对外)
              <el-tooltip
                class="item"
                effect="dark"
                content="此文件将下发给供应商，请认真核对文件内容。"
                placement="top-start"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </span>
            <el-button
              icon="el-icon-document"
              type="primary"
              size="small"
              @click="asyncFile('cgglCgwjGroupId','cgglCgwjGroupIdDuiWai')"
              style="margin-bottom: 16px"
              :disabled="readonly"
            >与采购文件(对内)一致</el-button>
            <zs-upload
              :isDisabled="readonly"
              drag
              :multiple="false"
              :fileSize="100"
              :isNeedFuGai="true"
              v-model="inquireForm.cgglCgwjGroupIdDuiWai"
            >
            </zs-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="cgglQtfjGroupIdDuiWai">
            <span slot="label">
              其他文件(对外)
              <el-tooltip
                class="item"
                effect="dark"
                content="此文件将下发给供应商，请认真核对文件内容。"
                placement="top-start"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </span>
            <el-button
              icon="el-icon-document"
              type="primary"
              size="small"
              @click="asyncFile('cgglQtfjGroupId', 'cgglQtfjGroupIdDuiWai')"
              style="margin-bottom: 16px"
              :disabled="readonly"
            >与其他文件(对内)一致</el-button>
            <zs-upload
              :isDisabled="readonly"
              drag
              :multiple="false"
              :fileSize="100"
              :limit="10"
              v-model="inquireForm.cgglQtfjGroupIdDuiWai"
            >
            </zs-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
import zsUpload from '@/components/zsUpload'
import store from '@/store'
export default {
  components: {
    zsUpload
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    inquireFormData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      inquireForm: {}
    }
  },
  created() {
  },
  methods: {
    // 同步文件
    asyncFile(params, newParams) {
      if (this.readonly) {
        return
      }
      store.dispatch('file_groupCopy', {
        groupGuid: this.inquireForm[params]
      })
        .then((res) => {
          if (res.data) {
            this.inquireForm[newParams] = res.data
          }
        })
    }
  },
  watch: {
    inquireFormData: {
      handler(val) {
        if (val) {
          this.inquireForm = val
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

